import axios from 'axios';

// Add a global interceptor to attach the JWT token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get all tenants
export const getTenants = async () => {
  const response = await axios.get(`${API_URL}/tenants`);
  return response.data;
};

// Get a single tenant
export const getTenant = async (id) => {
  const response = await axios.get(`${API_URL}/tenants/${id}`);
  return response.data;
};

// Create a new tenant
export const createTenant = async (tenantData) => {
  const response = await axios.post(`${API_URL}/tenants`, tenantData);
  return response.data;
};

// Update a tenant
export const updateTenant = async (id, tenantData) => {
  const response = await axios.put(`${API_URL}/tenants/${id}`, tenantData);
  return response.data;
};

// Delete a tenant
export const deleteTenant = async (id) => {
  const response = await axios.delete(`${API_URL}/tenants/${id}`);
  return response.data;
}; 